export default "/images/luxemburguer.svg?5b238428ba9d0af82a31b57e60198747";